import React, { useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const RulesPopup = ({ onClose, onSave }) => {
  const [rules, setRules] = useState("");

  const handleSave = () => {
    onSave(rules); // Envía el contenido del editor al componente padre
    onClose(); // Cierra el popup
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-6 rounded-lg w-11/12 max-w-2xl max-h-[90vh] flex flex-col">
        <h2 className="text-xl font-bold mb-4">Editar Reglamento</h2>
        <div className="flex-1 overflow-y-auto mb-4">
          {" "}
          {/* Contenedor con scroll */}
          <ReactQuill
            value={rules}
            onChange={setRules}
            theme="snow"
            modules={{
              toolbar: [
                [{ header: [1, 2, false] }],
                ["bold", "italic", "underline", "strike"],
                [{ list: "ordered" }, { list: "bullet" }],
                ["link", "image"],
                ["clean"],
              ],
            }}
            formats={[
              "header",
              "bold",
              "italic",
              "underline",
              "strike",
              "list",
              "bullet",
              "link",
              "image",
            ]}
          />
        </div>
        <div className="mt-4 flex justify-end">
          <button
            onClick={onClose}
            className="mr-2 px-4 py-2 bg-gray-300 rounded-lg"
          >
            Cancelar
          </button>
          <button
            onClick={handleSave}
            className="px-4 py-2 bg-blue-500 text-white rounded-lg"
          >
            Guardar
          </button>
        </div>
      </div>
    </div>
  );
};

export default RulesPopup;
